import {createContext, useContext} from 'react';

export type ReturnDetailsCollectionSessionCredentials = {
  sessionId: string;
  clientSecret: string;
  publishableKey: string;
};

export const ReturnDetailsCollectionContext =
  createContext<ReturnDetailsCollectionSessionCredentials | null>(null);

export const useReturnDetailsCollectionContext = () => {
  const context = useContext(ReturnDetailsCollectionContext);

  if (!context) {
    throw new Error(
      'useReturnDetailsCollectionContext must be used within ReturnDetailsCollectionContextProvider',
    );
  }

  return context;
};
